import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION, NOTIFICATION_TYPE } from '../../../constants/common'
import { NotificationInline } from '../../Notification'
import { QA_NAME_GRETA_AI_CHAT_SOURCE_OUTAGE } from '../GretaAIChat.constants'

import * as styles from './GretaAIChatSourceOutageNotice.module.css'

function GretaAIChatSourceOutageNotice({ onRetry = EMPTY_FUNCTION }) {
  const { t } = useTranslation()

  return (
    <NotificationInline
      actions={[{ callback: onRetry, text: t('Greta.RetryButtonKey') }]}
      className={styles.notice}
      qaName={QA_NAME_GRETA_AI_CHAT_SOURCE_OUTAGE}
      text={t('Greta.FinanceUnavailableKey')}
      type={NOTIFICATION_TYPE.warning}
    />
  )
}

export default GretaAIChatSourceOutageNotice
